/** @format */

import {
	AddToCartEffects,
	addToCartReducers,
	FulfillmentButtonsEffects,
	fulfillmentButtonsReducer
} from '@pdp/add-to-cart/data-access';
import {
	BundlesEffects,
	bundlesReducer,
	HeaderLocationEffects,
	killswitchesReducer,
	ProductSelectionEffects,
	productSelectionReducers,
	WarrantiesEffects,
	warrantiesReducer
} from '@pdp/data-access/state';

import { CommonModule } from '@angular/common';
import { DynamicTemplateLoader } from '@shared/utils/services';
import { EffectsModule } from '@ngrx/effects';
import { MatDialogModule } from '@angular/material/dialog';
import { NgModule } from '@angular/core';
import { ProductContainerComponent } from './product-container/product-container.component';
import { ProductImageCarouselModule } from '@pdp/components';
import { ProductResolveGuard } from './product-resolve.guard';
import { ProductReviewsDataAccessModule } from '@product-reviews/data-access';
import { ProductSelectionState } from '@pdp/data-access/interfaces';
import { SnackbarModule } from '@shared/components';
import { SocialContentDataAccessModule } from '@social-content/data-access';
import { StoreModule } from '@ngrx/store';
import { attributesReducers } from '@pdp/attributes/data-access';

@NgModule({
	declarations: [ProductContainerComponent],
	imports: [
		CommonModule,
		MatDialogModule,
		ProductImageCarouselModule,
		ProductReviewsDataAccessModule,
		SocialContentDataAccessModule,
		SnackbarModule,
		EffectsModule.forRoot([
			AddToCartEffects,
			BundlesEffects,
			FulfillmentButtonsEffects,
			HeaderLocationEffects,
			ProductSelectionEffects,
			WarrantiesEffects
		]),
		StoreModule.forFeature<ProductSelectionState>('productSelection', {
			addToCart: addToCartReducers,
			attributes: attributesReducers,
			bundles: bundlesReducer,
			killswitches: killswitchesReducer,
			productSelectionCore: productSelectionReducers,
			warranties: warrantiesReducer
		}),
		StoreModule.forFeature('fulfillment', {
			fulfillmentButtonsReducer
		})
	],
	providers: [DynamicTemplateLoader, ProductResolveGuard],
	exports: [ProductContainerComponent]
})
export class ProductModule {}

export { ProductContainerComponent, ProductResolveGuard };
